import { render, staticRenderFns } from "./MusicPicker.vue?vue&type=template&id=1851b9f3&scoped=true"
import script from "./MusicPicker.vue?vue&type=script&lang=js"
export * from "./MusicPicker.vue?vue&type=script&lang=js"
import style0 from "./MusicPicker.vue?vue&type=style&index=0&id=1851b9f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1851b9f3",
  null
  
)

export default component.exports